import {inject, Injectable, OnDestroy} from '@angular/core';
import {Observable, Subject, Subscription} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {ProcessInfoDTO} from '../dto/process-info';
import {SseClient} from 'ngx-sse-client';
import {getHeadersEventSource} from '../../../utils/interceptors/http-header.interceptor';
import {map, tap} from 'rxjs/operators';
import {DeviceIdService} from '../../../utils/services/device-id.service';

@Injectable({
  providedIn: 'root',
})
export class ProcessInfoService implements OnDestroy {
  private readonly sseClient: SseClient = inject(SseClient);
  private readonly deviceIdService: DeviceIdService = inject(DeviceIdService);
  private readonly apiUrl = environment.apiBaseUrl + '/project/info';

  private connectionActive = false;
  private streamSubscription: Subscription | null = null;
  private destroy$ = new Subject<void>();

  processInfoStreamStream(): Observable<ProcessInfoDTO> {
    this.connectionActive = true;
    const headers = getHeadersEventSource(this.deviceIdService.getDeviceId());

    return this.sseClient.stream(
      `${this.apiUrl}`,
      {
        keepAlive: true,
        reconnectionDelay: 1
      },
      {headers},
      'GET'
    ).pipe(
      map(event => {
        if (event.type === 'error') {
          const errorEvent = event as ErrorEvent;
          console.error('SSE error:', errorEvent.error, errorEvent.message);
          throw new Error('SSE connection error');
        }
        const messageEvent = event as MessageEvent;
        return JSON.parse(messageEvent.data) as ProcessInfoDTO;
      }),
      tap({
        next: () => this.connectionActive = true,
        error: (err) => {
          console.error('Stream error:', err);
          this.connectionActive = false;
        },
        complete: () => {
          console.log('Stream completed unexpectedly');
          this.connectionActive = false;
        }
      })
    );
  }

  isConnectionActive(): boolean {
    return this.connectionActive;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.streamSubscription) {
      this.streamSubscription.unsubscribe();
      this.streamSubscription = null;
    }
  }

}

